var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-admin-bar',{attrs:{"title":"Admin panel"}}),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c('app-left-nav',{attrs:{"items":_vm.navButtons}})],1),_c('v-col',[_c('router-view')],1)],1)],1),_c('app-snackbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }